import gql from "graphql-tag";

const buildingMutations = {


    createBuilding: gql`
        mutation CreateBuilding($name: String, $code: String, $street: String, $number: String, $zip: String, $city: String, $district: String, $state: String, $acceptance: DateTime, $warranty_period_start: DateTime, $warranty_period_end: DateTime, $start_of_construction: DateTime, $completed: Boolean, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $indexed: Boolean, $defective: Boolean, $defective_message: String, $builder_id: Int, $contact_id: Int, $user_id: Int, $parent_id: Int, $cost_center_id: Int) {
            createBuilding(name: $name, code: $code, street: $street, number: $number, zip: $zip, city: $city, district: $district, state: $state, acceptance: $acceptance, warranty_period_start: $warranty_period_start, warranty_period_end: $warranty_period_end, start_of_construction: $start_of_construction, completed: $completed, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, indexed: $indexed, defective: $defective, defective_message: $defective_message, builder_id: $builder_id, contact_id: $contact_id, user_id: $user_id, parent_id: $parent_id, cost_center_id: $cost_center_id) {
                id,
                name,
                code,
                street,
                number,
                zip,
                city,
                district,
                state,
                acceptance,
                warranty_period_start,
                warranty_period_end,
                start_of_construction,
                completed,
                created_at,
                updated_at,
                deleted_at,
                indexed,
                defective,
                defective_message,
                builder_id,
                contact_id,
                user_id,
                parent_id,
                cost_center_id
            }
        }
    `,
    updateBuilding: gql`
        mutation UpdateBuilding($id: ID!, $name: String, $code: String, $street: String, $number: String, $zip: String, $city: String, $district: String, $state: String, $acceptance: DateTime, $warranty_period_start: DateTime, $warranty_period_end: DateTime, $start_of_construction: DateTime, $completed: Boolean, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $indexed: Boolean, $defective: Boolean, $defective_message: String, $builder_id: Int, $contact_id: Int, $user_id: Int, $parent_id: Int, $cost_center_id: Int) {
            updateBuilding(id: $id, name: $name, code: $code, street: $street, number: $number, zip: $zip, city: $city, district: $district, state: $state, acceptance: $acceptance, warranty_period_start: $warranty_period_start, warranty_period_end: $warranty_period_end, start_of_construction: $start_of_construction, completed: $completed, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, indexed: $indexed, defective: $defective, defective_message: $defective_message, builder_id: $builder_id, contact_id: $contact_id, user_id: $user_id, parent_id: $parent_id, cost_center_id: $cost_center_id) {
                id,
                name,
                code,
                street,
                number,
                zip,
                city,
                district,
                state,
                acceptance,
                warranty_period_start,
                warranty_period_end,
                start_of_construction,
                completed,
                created_at,
                updated_at,
                deleted_at,
                indexed,
                defective,
                defective_message,
                builder_id,
                contact_id,
                user_id,
                parent_id,
                cost_center_id
            }
        }
    `,
};

export default buildingMutations;
